import { render, staticRenderFns } from "./TierBubble.vue?vue&type=template&id=e1b1f802&scoped=true&"
import script from "./TierBubble.vue?vue&type=script&lang=js&"
export * from "./TierBubble.vue?vue&type=script&lang=js&"
import style0 from "./TierBubble.vue?vue&type=style&index=0&id=e1b1f802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b1f802",
  null
  
)

export default component.exports